export default __webpack_public_path__ + "static/media/ico-agenproperti.86610941.webp";